import React from "react";
import Select from "@components/select";
import { usePendingPrefill, useSetDefaultValue } from "@hooks/index";
import { useFormikContext } from "formik";

export const PrefillSelect = (props) => {
  const { name, title, options, toolTipText, placeholder, loading, defaultValue, previewMapper } = props;
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  
  useSetDefaultValue(name, defaultValue);
  usePendingPrefill(name);

  return (
    <Select
      name={name}
      title={title}
      options={options}
      toolTipText={toolTipText}
      isPlaceHolder={!!placeholder}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values[name]}
      loading={loading}
      previewMapper={previewMapper}
      errorMessage={touched[name] ? errors[name] : ""}
    />
  );
}